import { forwardRef, MutableRefObject } from "react";
import type { EditorRefApi, LiteTextEditorProps } from "../core/types/editor";
import { EditorWrapper } from "../editor-wrapper";

const LiteTextEditor = (props: LiteTextEditorProps) => {
  const { extensions = [] } = props;

  return <EditorWrapper {...props} extensions={extensions} />;
};

const LiteTextEditorWithRef = forwardRef<EditorRefApi, LiteTextEditorProps>(
  (props, ref) => (
    <LiteTextEditor
      {...props}
      forwardedRef={ref as MutableRefObject<EditorRefApi | null>}
    />
  )
);

LiteTextEditorWithRef.displayName = "LiteTextEditorWithRef";

export { LiteTextEditorWithRef };
